import config from '@/config';

export class Storage {

  static set(key: string, value: any) {
    localStorage.setItem(config.scope + key, JSON.stringify(value));
  }

  static get<T = any>(key: string): T | undefined {
    const str = localStorage.getItem(config.scope + key);
    if (str) {
      return JSON.parse(str);
    }
  }

  static del(key: string) {
    localStorage.removeItem(config.scope + key);
  }
}
